<template>
  <div id="logout">
    <el-form>
       <el-form-item style="float: left;">
        <img src="../assets/altai_logo_v2.png" alt="logo" />
      </el-form-item>
      <el-form-item style="float: right;" v-loading:isLoading>
<!--        <i class="el-icon-user-solid marginR20"></i>-->
        <font-awesome-icon icon="sign-out-alt" size="lg"/>
        <a @click="logout" class="logout-text">Logout</a>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { requestLogout } from '../api'
import * as types from '../store/types'
import store from '../store/store'
import { mapState } from 'Vuex'
export default {
  name: 'Logout',
  isLoading: false,
  computed: mapState({
    loginUserName: state => state.loginuser
  }),
  methods: {
    logout () {
      this.isLoading = true
      requestLogout().then(data => {
        console.log('requestLogout')
        console.log(data)
        let { msg, status, user } = data

        console.log('status = %d, user = %s, msg = %s', status, user, msg)
        if (status !== 200) {
          this.$message({message: msg, type: 'error'})
        } else {
          this.$store.commit(types.LOGOUT)
          this.$router.push({path: '/login'}).catch(error => {
            if (error) {
              console.log(error.stack)
            }
          })
        }
        this.isLoading = false
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        this.$store.commit(types.LOGOUT)
        this.$router.push({path: '/login'}).catch(error => {
          if (error) {
            console.log(error.stack)
          }
        })
        this.isLoading = false
      })
    },
    showLoginName () {
      this.loginUserName = store.state.loginuser
      alert('====>' + this.loginUserName)
    }
  }
}
</script>

<style scoped>
  .logout-text{
    font-size: 20px;
    /* font-weight: 500; */
    font-weight: bold;
    letter-spacing: .005em;
    line-height: 26px;
    /*color: white;*/
    color: #1f1f1f;
    cursor: pointer;
    ext-decoration: underline;
  }
  .marginR20{
    margin-right: 20px;
  }
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// Logout.vue?5cd1b4b1